module.exports = __webpack_public_path__ + "img/wen_write.769ee8d0.png";